import classNames from 'classnames';
import styles from './styles/Notification.module.scss';
import {observer} from 'mobx-react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {fetchState} from "../../../../stores/OrganizationStore";
import useDelayedFetchStates from "../../../../hooks/useDelayedFetchStates";

const notificationClassNames = {
    enter: styles.transitionEnter,
    appear: styles.transitionAppear,
    enterActive: styles.transitionEnterActive,
    appearActive: styles.transitionAppearActive,
    enterDone: styles.transitionEnterDone,
    appearDone: styles.transitionAppearDone,
    exit: styles.transitionExit,
    exitActive: styles.transitionExitActive,
    exitDone: styles.transitionExitDone,
};

const NotificationManager = observer(() => {
    const delayedFetchStates = useDelayedFetchStates();

    const containerClassName = classNames({
        [styles.container]: true,
    });

    return (
        <TransitionGroup className={containerClassName}>
            {Object.values(delayedFetchStates)
                .map((request, i) => {
                    const notificationClassName = classNames({
                        [styles.notification]: true,
                        // [styles.notificationLoading]: preservedRequest?.value === fetchState["PENDING RESPONSE"] || preservedRequest?.value === fetchState["PENDING SCHEMA"],
                        [styles.notificationSuccess]: request?.value === fetchState.SUCCESS,
                        [styles.notificationError]: request?.value === fetchState.FAILURE,
                    });

                    return <CSSTransition classNames={notificationClassNames} timeout={250}>
                        <div className={notificationClassName}>
                            <h3>{request?.message}</h3>
                        </div>
                    </CSSTransition>
                })}
        </TransitionGroup>
    )
});

export default NotificationManager;
